/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  ACTIVATE_USER: {},
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.klefki.userList.activateUser',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        START: { target: 'ACTIVATE_USER' },
      },
    },
    ACTIVATE_USER: {
      invoke: {
        id: 'activateUser',
        src: 'activateUser',
        onDone: {
          target: 'ACTIVATE_USER_SUCCESS',
          actions: ['successAction'],
        },
        onError: {
          target: 'ACTIVATE_USER_FAILED',
          actions: ['failureAction'],
        },
      },
    },
    ACTIVATE_USER_SUCCESS: {
      on: {
        START: { target: 'ACTIVATE_USER' },
      },
    },
    ACTIVATE_USER_FAILED: {
      on: {
        START: { target: 'ACTIVATE_USER' },
      },
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
